import ExcelJS from 'exceljs';
import ff from './ff';

// expo install exceljs
/*
 */

export default class myXL {

static myXL_dwlFile = (pd={ // ld_hdrss, ld_bdyss を lld_isss でひとまとめに定義したい
  file: null,
  ld_shtss: [
    {
      sht: null,
      ld_hdrss: null,
      ld_bdyss: null,
    }
  ],
  n_ver: 0,
}) => new Promise( async _o_end1 => {

  if (pd.n_ver == 2) {

    const _wb = new ExcelJS.Workbook();

    pd.ld_shtss.map( _d_shts => {
      const _ws = _wb.addWorksheet(_d_shts.sht);
      _ws.columns = _d_shts.ld_hdrss;
      _ws.addRows(_d_shts.ld_bdyss);
    });

    const _uint8Array = await _wb.xlsx.writeBuffer()
    const _blob = new Blob([_uint8Array], { type: "application/octet-binary" });
    const _url = window.URL.createObjectURL(_blob);
    const _a = document.createElement("a");
    _a.href = _url;
    _a.download = pd.file; //フォーマットによってファイル拡張子を変えている
    _a.click();
    _a.remove();

    _o_end1();
  }
  else {

    const _wb = new ExcelJS.Workbook();
    _wb.addWorksheet(pd.sht);

    const _ws = _wb.getWorksheet(pd.sht);

    _ws.columns = pd.ld_hdrss;
    _ws.addRows(pd.ld_bdyss);
    
    const _uint8Array = await _wb.xlsx.writeBuffer()
    const _blob = new Blob([_uint8Array], { type: "application/octet-binary" });
    const _url = window.URL.createObjectURL(_blob);
    const _a = document.createElement("a");
    _a.href = _url;
    _a.download = pd.file; //フォーマットによってファイル拡張子を変えている
    _a.click();
    _a.remove();

    _o_end1();
  };

});

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
